import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAqiLSaZiTacTXv6CN3OGZA49sG_ktCe5E",
  authDomain: "link2me-24d2c.firebaseapp.com",
  projectId: "link2me-24d2c",
  storageBucket: "link2me-24d2c.firebasestorage.app",
  messagingSenderId: "1093005594821",
  appId: "1:1093005594821:web:ff9c54cd1e41cfa74ce0ac"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);